import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { UserForm } from '@/components/admin/user-form';

export function AdminUserNewPage() {
  return (
    <div className="container-narrow py-8 max-w-xl">
      <Button asChild variant="ghost" size="sm" className="mb-4">
        <Link to="/admin/utenti">
          <ArrowLeft className="h-4 w-4" /> Utenti
        </Link>
      </Button>
      <h1 className="font-serif text-2xl font-semibold mb-6">Nuovo utente</h1>
      <UserForm />
    </div>
  );
}
